import { Box, Link, Typography } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'

import style from './style'
import Section from '../../components/Section'

const Home = () => {
  const intl = useIntl()

  return (
    <Box sx={style.container}>
      <Box sx={style.titleContainer}>
        <Typography variant="h1" fontSize={48} color="secondary">
          <FormattedMessage id="Home.Title" defaultMessage="QuantumBio Vins" />
        </Typography>
        <Typography variant="h2" fontSize={32} fontStyle="italic" color="secondary">
          <FormattedMessage
            id="Home.Subtitle"
            defaultMessage='"The right wine for the right occasion"'
          />
        </Typography>
      </Box>

      <Section
        title={intl.formatMessage({
          id: 'Home.WhyQuantumBio.Title',
          defaultMessage: 'Why QuantumBio Vins?',
        })}
        imgSrc="/images/home1.jpg"
      >
        <FormattedMessage
          id="Home.WhyQuantumBio.Content"
          defaultMessage="Whether you drink wine occasionally or regularly, it is always appreciated to have at home, a selection of wines that you can open for each specific occasion. If a friend pops up for the apero, or if your boss is coming for dinner, you will likely not open the same bottle of wine. Furthermore, if you are having a pepperoni pizza or if you are cooking fish in a creamy sauce, you will want to pair your dishes with different wines.{br}{br}QuantumBio was created to help you optimise your wine cellar based on your habits, tastes, equipement (i.e. wine storage capabilities) and budget, in order to allow you to always « have the right wine for the right occasion »."
          values={{ br: <br /> }}
        />
      </Section>

      <Section
        title={intl.formatMessage({
          id: 'Home.WhoQuantumBio.Title',
          defaultMessage: 'Who is behind QuantumBio Vins?',
        })}
        imgSrc="/images/home2.jpg"
        withLightBackground
        reverseContent
      >
        <FormattedMessage
          id="Home.WhoQuantumBio.Content"
          defaultMessage="Juliette Plun-Favreau created QuantumBio Vins after she passed her professional sommelier certificate wih the {link}. Passionate about wines for many years, she is sourcing small wine producers making high quality wines, not easily accessible in Switzerland.{br}{br}Those producers take great care of the environment and of not adding too many sulfites into their wines. Furthermore, all the selected wines are ready to drink, and don’t need to be aged in a cellar."
          values={{
            br: <br />,
            link: (
              <Link
                href="https://assp-sr.ch/a-propos-de-lassp/"
                target="_blank"
                rel="noreferrer"
                sx={style.link}
              >
                <FormattedMessage
                  id="Home.WhoQuantumBio.Content.Link"
                  defaultMessage="Association Suisse de Sommellerie Professionnelle"
                />
              </Link>
            ),
          }}
        />
      </Section>
    </Box>
  )
}

export default Home
